import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 46 41"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M42.573.85c-2.078-.715-4.315-.085-5.69 1.61l-10.58 13.035-13.38-13.304C10.953.23 8.178-.47 5.506.318 2.838 1.107.85 3.233.316 5.868c-.008.043-.02.082-.027.128C.182 6.443 0 7.19 0 11.326v24.073c0 2.169 1.344 4.03 3.427 4.75.569.194 1.15.291 1.723.291a5.1 5.1 0 0 0 3.968-1.9l10.58-13.036 13.378 13.304C34.515 40.238 36.38 41 38.321 41c.72 0 1.45-.105 2.174-.319 2.667-.789 4.655-2.915 5.189-5.55.008-.043.02-.081.028-.128.106-.447.288-1.193.288-5.329V5.6c0-2.169-1.344-4.034-3.427-4.75m-4.762 2.336c1.285-1.582 3.099-1.675 4.371-1.236s2.632 1.629 2.632 3.65v24.074c0 2.227-.051 3.428-.11 4.12l-17.56-17.463zM8.193 37.813c-1.284 1.582-3.099 1.675-4.371 1.236S1.19 37.42 1.19 35.399V11.325c0-2.227.051-3.428.11-4.12l17.56 17.463z"
    }, null, -1)
  ])))
}
export default { render: render }